import React, { useEffect, useState } from 'react';
import { useList, useRole } from 'components/hooks';
import { Alert, ErrorScreen, ModalAlert } from 'components/common';
import RoleListDumb from './RoleListDumb';
import { useHistory, withRouter, useLocation } from 'react-router-dom';
import { ROUTES } from 'consts';
import withRequest from 'hoc/withRequest';
import queryString from 'query-string';

const RoleListSmart = (props) => {
  const { getContentList, content, error, isLoaded } = useList('roles');
  const history = useHistory();
  const location = useLocation();
  const [openModal, setOpenModal] = useState(false);
  const [roleSelected, setRoleSelected] = useState(null);
  const role = useRole();
  let { search } = queryString.parse(props.location.search);

  useEffect(() => {
    handleListPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const handleListPage = () => {
    const query = {}
    if (search) {
      query.search = search;
    }
    getContentList({ query });
  };

  useEffect(() => {
    if (role.success.get || role.success.post || role.success.put || role.success.delete) {
      handleListPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ role.success.get, role.success.post, role.success.put, role.success.delete ]);

  const handleCleanUp = () => {
    role.cleanUpMessage();
  }

  const handleCreate = () => {
    handleCleanUp();
    history.push(ROUTES.ROLE_CREATE);
  };

  const handleDelete = () => {
    const body = {
      roleId: roleSelected.id
    }
    role.deleteRole({ body });
    setOpenModal(false);
  };

  const handleModalDelete = (role) => {
    setRoleSelected(role);
    setOpenModal(true);
  };

  const handleSearch = (data) => {
    const {pathname, search} = location;
    const currentLocation = `${pathname}${search}`;
    let routeToPush = `${ROUTES.ROLE_LIST}`;
    if (data.search !== '') {
      routeToPush = `${routeToPush}?search=${data.search}`
    }
    if (currentLocation === routeToPush) {
      handleListPage();
    } else {
      history.push(routeToPush);
    }
  };

  const handleEdit = (role) => {
    handleCleanUp();
    history.push(`${ROUTES.ROLE_EDIT}/${role.id}`);
  };


  const alerts = [
    {
      severity: 'success',
      open: role.success.post,
      message: 'roleList.components.alert.success',
    },
    {
      severity: 'success',
      open: role.success.delete,
      message: 'roleList.components.alert.deleteSuccess',
    },
    {
      severity: 'info',
      open: role.success.put,
      message: 'roleList.components.alert.putSuccess',
    },
    {
      severity: 'error',
      open: role.error.put,
      message: 'roleList.components.alert.error',
    },
    {
      severity: 'error',
      open: role.error.delete,
      message: 'roleList.components.alert.error',
    },
    {
      severity: 'error',
      open: role.error.post,
      message: 'roleList.components.alert.error',
    },
  ];


  return (
    <>
      { error ? (
        <ErrorScreen />
      ) : (
        <RoleListDumb
          isLoaded = { isLoaded }
          content = { content }
          handleCreate = { handleCreate }
          handleDelete = { handleModalDelete }
          handleEdit = { handleEdit }
          handleSearch = { handleSearch }
          searchValue={search}
        />
      )}

      { alerts.map((alert, index) => (
        <Alert
          key = { index }
          severity = { alert.severity }
          handleClose = { () => role.cleanUpMessage() }
          open = { alert.open }
          message = { alert.message }
        />
      ))}

      <ModalAlert
        open={ openModal }
        handleClose={ () => setOpenModal(false) }
        handleConfirm={ handleDelete }
      />
    </>

  )
}

export default withRequest(withRouter(RoleListSmart));
